export const MATCH_SCORE_IMG_SET = [
  {
    key: "h1_plus",
    img: "match-high-plus"
  },
  {
    key: "h1",
    img: "match-high"
  },
  {
    key: "med",
    img: "match-medium"
  },
  {
    key: "low",
    img: "match-low"
  }
];

export const PLAN_NEXT_LIST = [
  {
    key: 'strengths',
    label: 'Leverage your strengths'
  },
  {
    key: 'experience',
    label: 'Build experience'
  },
  {
    key: 'knowledge',
    label: 'Strengthen core knowledge'
  }
];

export const SKILLS_MAPPING = {
  VERY_HIGH: "Very High",
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low"
}

export const SKILLS_GAP_MAPPING = {
  VERY_HIGH: "Very Large",
  HIGH: "Large",
  MEDIUM: "Medium",
  LOW: "Low"
}